import ApiService from "../Services/ApiService";

export interface ContactRequestPayload {
    subject: string;
    message: string;
    /** Téléphone de rappel saisi dans le formulaire, facultatif. */
    phone?: string;
    /** Contexte libre ajouté par l'écran appelant (ex. « Cours n°123 du 12/10 »). */
    context?: string;
}

/**
 * Formulaire « Nous contacter » : la demande est transmise par le serveur au
 * canal support Slack et par mail à l'équipe. L'expéditeur est l'utilisateur
 * connecté, le serveur ne lit aucune identité dans le corps de la requête.
 */
export default abstract class SupportRepository {
    public static sendContactRequest(payload: ContactRequestPayload): Promise<{ sent: boolean }> {
        return ApiService.post(`/support/v2/contact-requests`, payload) as Promise<{ sent: boolean }>;
    }
}
